import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ActionButtonsGroup from '../containers/ActionButtonsGroup';
import { TableBaseProps } from '../../types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import { Fragment } from 'react/jsx-runtime';

export default function TableBase<T>({ headers, data, detail, showDetail, rootData }: TableBaseProps<T>) {
    return (
        <TableContainer >
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {headers.map((h) => <TableCell
                            key={h.label}
                            align={h.align || 'left'}
                            component="th">
                            {h.header ? <Button
                                startIcon={<FontAwesomeIcon icon="up-down" />}
                                sx={{ minWidth: 'auto' }}
                                color={h.header.active ? 'secondary' : 'primary'}
                                onClick={h.header.action}
                                size='small'
                            >
                                {h.label}
                            </Button> : h.label}
                        </TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((d, idx) => <Fragment key={idx}>
                        <TableRow>
                            {headers.map((h) => <TableCell className='gray' key={h.label} align={h.align || 'left'} about={h.label} style={{ background: showDetail && showDetail(d, idx) ? '#ffd8' : '' }}>
                                {h.options && <ActionButtonsGroup items={h.options({ data: d, index: idx, totalElements: data.length, rootData: rootData })} />}
                                {h.information && h.information({ data: d, index: idx, totalElements: data.length, rootData: rootData })}
                            </TableCell>)}
                        </TableRow>
                        {showDetail && showDetail(d, idx) && <TableRow>
                            <TableCell colSpan={headers.length} className='showDetail'>
                                {detail?.node}
                            </TableCell>
                        </TableRow>}
                    </Fragment>)}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
